// extracted by mini-css-extract-plugin
export default {"slide":"Slider_slide__q2VCC","swiper-button-prev":"Slider_swiper-button-prev__fkkh4","swiper-button-next":"Slider_swiper-button-next__mGi-K"};